import { Component, OnInit, ViewChild } from '@angular/core';
import { HasPermissions, Permissions } from '../../core/services/permissions/permissions.model';
import { PermissionsService } from '../../core/services/permissions/permissions.service';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { ProjectStepRow, ProjectType, Project, ProjectStep } from '../projects.model';
import { ProjectsRest } from '../projects.rest';
import { GridComponent } from '../../core/shared/grid/grid.component';
import { ProjectService } from '../projects.service';
import { GoupedColumn, GroupFunction, SortedColumn, GridMainFilter } from '../../core/shared/grid/grid.model';
import { GridParamsRestoringService } from '../../core/services/grid-params-restoring/grid-params-restoring.service';
import { GridParamsRestorable } from '../../core/services/grid-params-restoring/grid-params-restoring.model';

@Component({
  selector: 'app-projectstep-list',
  templateUrl: './projectstep-list.component.html',
  styleUrls: ['./projectstep-list.component.scss']
})
export class ProjectStepListComponent implements OnInit, HasPermissions, GridParamsRestorable {
  public initialFilters: any = undefined;
  public initialPageNumber: number = 0;
  public initialPageSize: number;
  public initialSortedColumn: SortedColumn = undefined;
  public previousMainFilters: any = undefined;
  public detailsPath: string = "";
  public mainFilter = {};
  permissions: Permissions;
  private path: string;
  private projectType: ProjectType;
  private project: Project;
  private projectSteps: ProjectStepRow[];
  public editedItemId: number;
  @ViewChild(GridComponent) grid: GridComponent;


  
  private headers = [
    { displayName: 'Nazwa', propertyName: 'name', propertyType: 'string' },
    { displayName: 'Data rozpoczęcia', propertyName: 'startDate', propertyType: 'date' },
    { displayName: 'Data końcowa', propertyName: 'endDate', propertyType: 'date' },
    { displayName: 'Płatnik', propertyName: 'payerName', propertyType: 'string' },
    { displayName: 'Czas pracy', propertyName: 'timeSpent', propertyType: 'number' },
    { displayName: 'Czas fakturowany', propertyName: 'invoiceTime', propertyType: 'number' },
    { displayName: 'Budżet', propertyName: 'budget', propertyType: 'number' },
    { displayName: 'Status', propertyName: 'objectStateName', propertyType: 'string' },
    { displayName: 'Publiczny', propertyName: 'isPublic', propertyType: 'bool' }
  ];

  private headers2 = [
    { displayName: 'Nazwa', propertyName: 'name', propertyType: 'string' },
    { displayName: 'Data rozpoczęcia', propertyName: 'startDate', propertyType: 'date' },
    { displayName: 'Data końcowa', propertyName: 'endDate', propertyType: 'date' },
    { displayName: 'Płatnik', propertyName: 'payerName', propertyType: 'string' },
    { displayName: 'Czas pracy', propertyName: 'timeSpent', propertyType: 'number' },
    { displayName: 'Czas fakturowany', propertyName: 'invoiceTime', propertyType: 'number' },    
    { displayName: 'Status', propertyName: 'objectStateName', propertyType: 'string' },
    { displayName: 'Publiczny', propertyName: 'isPublic', propertyType: 'bool' }    
  ];

  private columnsToGroup: GoupedColumn[] = [
    { name: 'timeSpent', func: GroupFunction.sum },
    { name: 'invoiceTime', func: GroupFunction.sum },
    { name: 'budget', func: GroupFunction.sum }
  ];

  private columnsToGroup2: GoupedColumn[] = [
    { name: 'timeSpent', func: GroupFunction.sum },
    { name: 'invoiceTime', func: GroupFunction.sum }
  ];

  constructor(
    private permissionService: PermissionsService,
    private router: Router,
    private route: ActivatedRoute,
    private rest: ProjectsRest,
    private projectService: ProjectService,
    private gridParamsRestoringService: GridParamsRestoringService) { }

  ngOnInit() {
    this.setPermissions('ProjectStep');
    this.route.queryParams.subscribe((params: Params) => {
      this.projectType = parseInt(params.projectType);
      this.tryRestoreFiltersAndPage();
    });
  }

  public setModel(project: Project, projectType: ProjectType, projectSteps: ProjectStepRow[]) {
    //this.path = `api/projects/getprojectsteps/${project.id}`;
    this.projectSteps = projectSteps;
    this.projectType = projectType;
    this.project = project;
  }

  setPermissions(claimType: string): void {
    this.permissions = this.permissionService.getUserPermissions(claimType);
  }

  private onRowEdit(row: ProjectStepRow) {
    this.gridParamsRestoringService.saveCurrentGridParams(this.grid, row.id, undefined, true);
    this.projectService.passProject(this.project);
    this.projectService.setSelectedTab(2);
    switch (this.projectType) {
      case ProjectType.Project:
        this.router.navigate(["projectstep", row.name], { queryParams: { id: row.id, projectType: this.projectType }, relativeTo: this.route });
        break;
      case ProjectType.Order:
        this.router.navigate(["orderstep", row.name], { queryParams: { id: row.id, projectType: this.projectType }, relativeTo: this.route });
        break;
      case ProjectType.Consultations:
        this.router.navigate(["consultationstep", row.name], { queryParams: { id: row.id, projectType: this.projectType }, relativeTo: this.route });
        break;
      case ProjectType.Service:
        this.router.navigate(["servicestep", row.name], { queryParams: { id: row.id, projectType: this.projectType }, relativeTo: this.route });
        break;
      default:
        this.router.navigate(["projectstep", row.name], { queryParams: { id: row.id, projectType: this.projectType }, relativeTo: this.route });
        break;
    }
  }

  private onRowAdd() {
    if (!this.project.customerId || this.project.customerId === 0 || !this.project.customerName) {
      sweetAlert("Należy wybrać kontrahenta");
      return;
    }
    this.projectService.passProject(this.project);
    this.projectService.setSelectedTab(2);
    switch (this.projectType) {
      case ProjectType.Project:
        this.router.navigate(["projectstep", 'new'], { queryParams: { id: 0, projectType: this.projectType }, relativeTo: this.route });
        break;
      case ProjectType.Order:
        this.router.navigate(["orderstep", 'new'], { queryParams: { id: 0, projectType: this.projectType }, relativeTo: this.route });
        break;
      case ProjectType.Consultations:
        this.router.navigate(["consultationstep", 'new'], { queryParams: { id: 0, projectType: this.projectType }, relativeTo: this.route });
        break;
      case ProjectType.Service:
        this.router.navigate(["servicestep", 'new'], { queryParams: { id: 0, projectType: this.projectType }, relativeTo: this.route });
        break;
      default:
        this.router.navigate(["projectstep", 'new'], { queryParams: { id: 0, projectType: this.projectType }, relativeTo: this.route });
        break;
    }
  }

  private onRowDelete(row: ProjectStepRow) {
    let buttons = {
      yes: { text: "Tak", value: "yes" },
      no: { text: "Nie", value: "no" }
    }

    let message = `Czy na pewno usunąć etap projektu ${row.name}`;

    sweetAlert(message, {
      buttons: buttons
    }).then((value) => {
      switch (value) {
        case "yes":
          if (row.id <= 0) {
            sweetAlert(`Usunięto etap projektu ${row.name}`);
            this.projectSteps.splice(this.projectSteps.indexOf(row), 1);
            this.project.newProjectSteps.splice(this.projectSteps.indexOf(row), 1);
            this.grid.refreshData();
          }
          else {
            this.rest.deleteProjectStep(row.id).subscribe((result: boolean) => {
              if (result){
                sweetAlert(`Usunięto etap projektu ${row.name}`);
                this.projectSteps.splice(this.projectSteps.indexOf(row), 1);
                this.grid.refreshData();
              }
            });
          }
          break;
      }
    });
  }

  private tryRestoreFiltersAndPage() {
    let path = this.getDetailsPath();
    let gridParams = this.gridParamsRestoringService.getPreviousGridParams(path, true);
    if (!gridParams) {
      return;
    }
    this.initialFilters = gridParams.initialFilters;
    this.initialSortedColumn = gridParams.sortedColumn;
    this.previousMainFilters = gridParams.previousMainFilters;
    this.initialPageNumber = gridParams.initialPageNumber;
    this.initialPageSize = gridParams.initialPageSize;
    this.editedItemId = gridParams.editedItemId;
    if (gridParams.mainFilter) {
      this.mainFilter = gridParams.mainFilter;
    }
  }

  private getDetailsPath(): string {
    switch (this.projectType) {
      case ProjectType.Project:
        return "projectstep"
      case ProjectType.Order:
        return "orderstep"
      case ProjectType.Service:
        return "servicestep"
      case ProjectType.Consultations:
        return "consultationstep"
      default:
        break;
    }
  }
}
